function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useRef, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import Box from "../Box";
import classes from "../../../design-system/scss/components/dialog.module.scss";
import { DialogContext } from "./index";
import { jsx as _jsx } from "react/jsx-runtime";
var onKey = function onKey(target, key, expected, func) {
  if (target.tagName.toLowerCase() === 'input') {
    return;
  }
  if (key === expected) {
    func();
  }
};
var DialogBox = function DialogBox(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var close = useContext(DialogContext);
  var ref = useRef(null);
  var handleKeyUp = useCallback(function (_ref2) {
    var target = _ref2.target,
      key = _ref2.key;
    return onKey(target, key, 'Escape', close);
  }, [close]);
  var handleKeyPress = useCallback(function (_ref3) {
    var target = _ref3.target,
      key = _ref3.key;
    return onKey(target, key, 'Enter', close);
  }, [close]);
  useEffect(function () {
    document.body.addEventListener('keyup', handleKeyUp);
    document.body.addEventListener('keypress', handleKeyPress);
    return function cleanup() {
      document.body.removeEventListener('keyup', handleKeyUp);
      document.body.removeEventListener('keypress', handleKeyPress);
    };
  }, [handleKeyUp, handleKeyPress]);
  useEffect(function () {
    if (ref.current) {
      var current = document.activeElement;
      if (!current || !ref.current.contains(current)) {
        ref.current.focus();
      }
    }
  }, [ref.current]);
  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    role: "dialog",
    ref: ref,
    tabIndex: -1,
    background: true,
    className: classes['c-dialog']
  }, props), {}, {
    children: /*#__PURE__*/_jsx(Box, {
      flex: true,
      direction: "column",
      gutter: true,
      padding: true,
      height: 100,
      children: children
    })
  }));
};
DialogBox.propTypes = {
  children: PropTypes.node.isRequired
};
export default DialogBox;